export const TX_EXPORT_FIELDS = [
  'date',
  'type',
  'fromPortfolio',
  'toPortfolio',
  'outAmount',
  'outCurrency',
  'feeAmount',
  'feeCurrency',
  'fromAddress',
  'toAddress',
  'outTxId',
  'outTxUrl',
  'inAmount',
  'inCurrency',
  'inTxId',
  'inTxUrl',
  'orderId',
  'personalNote',
]
